import babajide from "../../../assets/images/babajide.png";
import takunbo from "../../../assets/images/takunbo.png";
import apostrophe from "../../../assets/images/apostrophe.png";
import "./Testimonials.scss";

const Testimonials = () => {
  return (
    <section className="testimonials container">
      <div className="testimonial">
        <div className="person-image-section">
          <img src={babajide} alt="person" className="person" />
          <div className="name">Babajide Sanwo-Olu</div>
          <div className="designation">
            Executive Governor, <br />
            Lagos State, Nigeria
          </div>
        </div>
        <div className="body-copy">
          <img src={apostrophe} className="apostrophe" alt="comment" />
          <div className="comment">
            Today, Lagos grapples with the tangible realities of climate change.
            Rising sea levels, extreme rainfall, and unprecedented heatwaves are
            not mere predictions but daily challenges that threaten our
            infrastructure, economy, and the very fabric of our society.{" "}
            <b>
              Yet, it is in these challenges that I see immense potential for
              Lagos to rise as a beacon of resilience and ingenuity.
            </b>
          </div>
        </div>
      </div>
      <div className="testimonial">
        <div className="body-copy">
          <img src={apostrophe} className="apostrophe" alt="comment" />
          <div className="comment">
            It gives me immense pride to introduce the Lagos Climate Adaptation
            and Resilience Plan (LCARP).{" "}
            <b>
              This document encapsulates our strategic response to the global
              climate crisis. Having successfully developed this plan,
            </b>{" "}
            we are on track to drive implementation and ensure the long-term
            resilience of Lagos. This plan is not a solitary effort of the
            government; it is a collective call to action.{" "}
            <b>The LCARP serves as our blueprint.</b>
          </div>
        </div>
        <div className="person-image-section">
          <img src={takunbo} alt="person" className="person" />
          <div className="name">Tokunbo Wahab</div>
          <div className="designation">
            Honourable Commissioner, Ministry Of Environment And Water
            Resources, <br />
            Lagos State, Nigeria{" "}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
